import React from 'react';

/**
 * Prototype-aligned page header + stat row using existing theme tokens.
 */
export const AdminPageHeader: React.FC<{
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}> = ({ title, subtitle, actions }) => (
  <div className="adm-page-top">
    <div className="adm-hdr-block">
      <h1 className="adm-hdr-title">{title}</h1>
      {subtitle && <p className="adm-hdr-sub">{subtitle}</p>}
    </div>
    {actions && <div className="adm-hdr-actions">{actions}</div>}
  </div>
);

export const AdminStatGrid: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="adm-sg">{children}</div>
);

export const AdminStatCard: React.FC<{
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
  iconVariant?: 'blue' | 'green' | 'amber' | 'purple';
}> = ({ label, value, icon, iconVariant = 'blue' }) => (
  <div className="adm-sc">
    {icon && <div className={`adm-sc-ico ${iconVariant}`}>{icon}</div>}
    <div>
      <div className="adm-sc-val">{value}</div>
      <div className="adm-sc-lbl">{label}</div>
    </div>
  </div>
);
